import { NavigateDataType } from '../types/NavigateData';
import { logger, loggerError } from './Log';
export function portalToMichelin(url, options) {
    try {
        logger('portalToMichelin');
        var portal = document.querySelector('#central-provider-portal');
        var child_1 = document.createElement('iframe');
        child_1.id = 'portal';
        child_1.src = url;
        portal.appendChild(child_1);
        // eslint-disable-next-line no-param-reassign
        options.origin = window.location.origin;
        var interval_1 = setInterval(function () {
            child_1.contentWindow.postMessage(options, url);
        }, 500);
        var callback_1 = function (data) {
            logger('portalToMichelin callback');
            if (data.data.type === NavigateDataType.NAVIGATE_SUCCESS) {
                clearInterval(interval_1);
                window.removeEventListener('message', callback_1);
            }
        };
        window.addEventListener('message', callback_1);
    }
    catch (error) {
        loggerError(error);
    }
}
//# sourceMappingURL=portalToMichelin.js.map